import React from "react";
import { Button, ButtonGroup, Modal } from "../../components/ui";

const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
};

const daysRemaining = (iso) => {
  if (!iso) return 0;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.max(0, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};

const EbayPolicyModal = ({ isOpen, variant, restrictedUntil, onConfirm, onCancel }) => {
  const days = daysRemaining(restrictedUntil);
  const dateStr = formatDate(restrictedUntil);

  let title, body;
  if (variant === "A") {
    title = "This listing was previously blocked by eBay";
    body = (
      <>
        This listing triggered an eBay policy violation (likely counterfeit) the last
        time it was published. Re-listing it with the same photos may cause another
        10-day account restriction.
      </>
    );
  } else if (variant === "B") {
    title = "eBay account is currently restricted";
    body = (
      <>
        Your eBay account cannot list new items until <strong>{dateStr}</strong>{" "}
        ({days} day{days === 1 ? "" : "s"} remaining). Attempting to publish now will
        fail and may extend the restriction.
      </>
    );
  } else if (variant === "C") {
    title = "eBay publish blocked — two issues";
    body = (
      <>
        <ul>
          <li>This listing was previously blocked by eBay for a policy violation.</li>
          <li>
            Your account is currently restricted from listing new items until{" "}
            <strong>{dateStr}</strong> ({days} day{days === 1 ? "" : "s"} remaining).
          </li>
        </ul>
        Publishing will fail and may extend the restriction.
      </>
    );
  } else {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      variant="dialog"
      size="sm"
      danger
      title={title}
      footer={
        <ButtonGroup align="end">
          <Button variant="ghost" size="sm" data-btn="ebay-publish-cancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="danger" size="sm" data-btn="ebay-publish-confirm" onClick={onConfirm}>
            Publish anyway
          </Button>
        </ButtonGroup>
      }
    >
      {body}
    </Modal>
  );
};

export default EbayPolicyModal;
